// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wa-upload-zone {
  display: block;
  cursor: pointer;
  border: 2px dashed #dbdfea;
  border-radius: 12px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  background: #f5f6fa;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;
}

.wa-upload-zone:hover,
.wa-upload-zone.is-dragging {
  border-color: #6576ff;
  background: #eef0ff;
  transform: translateY(-1px);
}

.wa-upload-zone__icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e5e9f2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  font-size: 1.5rem;
  color: #6576ff;
  transition: background-color 0.2s ease;
}

.wa-upload-zone:hover .wa-upload-zone__icon {
  background: #dfe3ff;
}

.wa-upload-zone__title {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.wa-upload-zone__hint {
  color: #8094ae;
  font-size: 0.8125rem;
  margin-bottom: 0;
}

.wa-upload-zone__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.wa-upload-zone__file {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #dbdfea;
  font-weight: 500;
}

.wa-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.wa-items-table td {
  vertical-align: middle;
}


/* Everything below the import banner is read-only while an import runs. */
.wa-locked {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.55;
}

.wa-filter-chips .btn {
  white-space: nowrap;
}

/* Flow position: Upload -> Cek kontak -> Import -> Hasil */
.wa-stepper {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
  gap: 0.5rem;
}

.wa-stepper li {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #8094ae;
  font-weight: 500;
}

.wa-stepper li:not(:last-child)::after {
  content: "";
  flex: 1 1;
  height: 2px;
  background: #e5e9f2;
}

.wa-stepper__dot {
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e5e9f2;
  color: #526484;
  font-size: 0.8125rem;
}

.wa-stepper li.is-current {
  color: #364a63;
}

.wa-stepper li.is-current .wa-stepper__dot {
  background: #6576ff;
  color: #fff;
}

.wa-stepper li.is-done .wa-stepper__dot {
  background: #1ee0ac;
  color: #fff;
}

.wa-stepper li.is-done::after {
  background: #1ee0ac;
}

/* Summary numbers — the main information on the page. */
.wa-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.wa-stat {
  border: 1px solid #e5e9f2;
  border-left-width: 4px;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
}

.wa-stat__value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  color: #364a63;
}

.wa-stat__label {
  font-weight: 600;
  color: #526484;
}

.wa-stat__hint {
  font-size: 0.75rem;
  color: #8094ae;
}

.wa-stat--neutral {
  border-left-color: #6576ff;
}

.wa-stat--success {
  border-left-color: #1ee0ac;
}

.wa-stat--warning {
  border-left-color: #f4bd0e;
}

.wa-stat--muted {
  border-left-color: #b7c2d0;
}

.wa-result-headline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.wa-details {
  border-top: 1px solid #e5e9f2;
  padding-top: 1rem;
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/chatImportWaBackup.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oFAAoF;AACtF;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;;AAGA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":[".wa-upload-zone {\n  display: block;\n  cursor: pointer;\n  border: 2px dashed #dbdfea;\n  border-radius: 12px;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  background: #f5f6fa;\n  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;\n}\n\n.wa-upload-zone:hover,\n.wa-upload-zone.is-dragging {\n  border-color: #6576ff;\n  background: #eef0ff;\n  transform: translateY(-1px);\n}\n\n.wa-upload-zone__icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #e5e9f2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n  font-size: 1.5rem;\n  color: #6576ff;\n  transition: background-color 0.2s ease;\n}\n\n.wa-upload-zone:hover .wa-upload-zone__icon {\n  background: #dfe3ff;\n}\n\n.wa-upload-zone__title {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.wa-upload-zone__hint {\n  color: #8094ae;\n  font-size: 0.8125rem;\n  margin-bottom: 0;\n}\n\n.wa-upload-zone__input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.wa-upload-zone__file {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #dbdfea;\n  font-weight: 500;\n}\n\n.wa-filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.375rem;\n}\n\n.wa-items-table td {\n  vertical-align: middle;\n}\n\n\n/* Everything below the import banner is read-only while an import runs. */\n.wa-locked {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.55;\n}\n\n.wa-filter-chips .btn {\n  white-space: nowrap;\n}\n\n/* Flow position: Upload -> Cek kontak -> Import -> Hasil */\n.wa-stepper {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.5rem;\n  gap: 0.5rem;\n}\n\n.wa-stepper li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #8094ae;\n  font-weight: 500;\n}\n\n.wa-stepper li:not(:last-child)::after {\n  content: \"\";\n  flex: 1;\n  height: 2px;\n  background: #e5e9f2;\n}\n\n.wa-stepper__dot {\n  flex: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #e5e9f2;\n  color: #526484;\n  font-size: 0.8125rem;\n}\n\n.wa-stepper li.is-current {\n  color: #364a63;\n}\n\n.wa-stepper li.is-current .wa-stepper__dot {\n  background: #6576ff;\n  color: #fff;\n}\n\n.wa-stepper li.is-done .wa-stepper__dot {\n  background: #1ee0ac;\n  color: #fff;\n}\n\n.wa-stepper li.is-done::after {\n  background: #1ee0ac;\n}\n\n/* Summary numbers — the main information on the page. */\n.wa-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.wa-stat {\n  border: 1px solid #e5e9f2;\n  border-left-width: 4px;\n  border-radius: 8px;\n  padding: 1rem;\n  background: #fff;\n}\n\n.wa-stat__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #364a63;\n}\n\n.wa-stat__label {\n  font-weight: 600;\n  color: #526484;\n}\n\n.wa-stat__hint {\n  font-size: 0.75rem;\n  color: #8094ae;\n}\n\n.wa-stat--neutral {\n  border-left-color: #6576ff;\n}\n\n.wa-stat--success {\n  border-left-color: #1ee0ac;\n}\n\n.wa-stat--warning {\n  border-left-color: #f4bd0e;\n}\n\n.wa-stat--muted {\n  border-left-color: #b7c2d0;\n}\n\n.wa-result-headline {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wa-details {\n  border-top: 1px solid #e5e9f2;\n  padding-top: 1rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
